import { render } from "./PathwaysDrugCard.vue?vue&type=template&id=6a43a064"
import script from "./PathwaysDrugCard.vue?vue&type=script&lang=js"
export * from "./PathwaysDrugCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__